import { AuthorizationCodeTokenClient, OidcUrlHelper } from '@ori/auth';
import { version as ReactVersion } from 'react';

import { App } from './App';
import { IDENTITY_CLIENT_ID } from './constants';
import type { AppConfiguration } from './models';
import { parseSpaConfig } from './utils';

export const render = async (root: HTMLElement) => {
  if (!root.dataset.config) {
    return false;
  }
  const config = parseSpaConfig(root.dataset.config, [
    'currentLanguage',
    'customerId',
    'globalApiUrl',
    'graphqlUrl',
    'identityUrl',
    'staticApiUrl',
    'tenant',
  ]);
  // extract token from URL; only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== 'production') {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    if (searchParams.has('state')) {
      const oidcUrlHelper = new OidcUrlHelper();
      const tokenClient = new AuthorizationCodeTokenClient({
        clientId: IDENTITY_CLIENT_ID,
        identityUrl: config.identityUrl,
      });
      oidcUrlHelper.storeAuthCodeFromParams(searchParams);
      await tokenClient.initializeTokenFromAuthorizationCode();
      oidcUrlHelper.handleRedirectAfterLogin();
    }
  }
  const configuration: AppConfiguration = {
    currentLanguage: config.currentLanguage,
    customerId: config.customerId,
    globalApiUrl: config.globalApiUrl,
    graphqlUrl: config.graphqlUrl,
    identityUrl: config.identityUrl,
    staticApiUrl: config.staticApiUrl,
    tenant: config.tenant,
  };
  if (ReactVersion.startsWith('18')) {
    const { createRoot } = await import('react-dom/client');
    createRoot(root).render(<App configuration={configuration} />);
  } else {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console -- log error to console
      console.error('react-dom/client cannot be imported using legacy render');
    }
    const { render: reactDomRender } = await import('react-dom');
    reactDomRender(<App configuration={configuration} />, root);
  }

  return true;
};
